import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "block-body" }
const _hoisted_4 = { class: "block-titles" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_slider = _resolveComponent("a-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "block-desc",
      style: {"margin-bottom":"0"},
      innerHTML: _ctx.text
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_slider, {
        value: _ctx.sliderValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sliderValue) = $event)),
        disabled: _ctx.status,
        min: _ctx.params.min,
        max: _ctx.params.max,
        marks: _ctx.params.marks,
        "tooltip-visible": "",
        "get-tooltip-popup-container": (triggerNode) => triggerNode.parentNode,
        "handle-style": 
          _ctx.wasChosen
            ? { 'border-color': _ctx.params.color }
            : { 'border-color': '#dbdcdd' }
        ,
        "track-style": 
          _ctx.wasChosen
            ? { 'background-color': _ctx.params.color }
            : { 'background-color': '#dbdcdd' }
        ,
        "active-dot-style": 
          _ctx.wasChosen
            ? { 'border-color': _ctx.params.color }
            : { 'border-color': '#dbdcdd' }
        ,
        class: "block-slider swiper-no-swiping",
        onAfterChange: _ctx.sliderAfterChange,
        onChange: _ctx.sliderChange
      }, null, 8, ["value", "disabled", "min", "max", "marks", "get-tooltip-popup-container", "handle-style", "track-style", "active-dot-style", "onAfterChange", "onChange"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          innerHTML: _ctx.params.borderMinText
        }, null, 8, _hoisted_5),
        _createElementVNode("div", {
          innerHTML: _ctx.params.borderMaxText
        }, null, 8, _hoisted_6)
      ])
    ])
  ]))
}